import request from '../../axios';

export interface IPostSendOtpCodePayload {
  national_code: string;
}
export const postSendOtpCode = async (payload: IPostSendOtpCodePayload) => {
  const {data}: {data: {bank_validation: string}} = await request.post(
    `/api/v2/payment/request-etebarito-otp`,
    {
      ...payload,
    },
  );
  return data;
};
